import React from 'react';
import ImgAvatarDefault from 'Assets/images/pages/web-chat/avatar-default.png';

import css from './CameraOff.less';

function CameraOff() {
  return (
    <div className={css.container}>
      <img src={ImgAvatarDefault} alt="news" className="image-avatar" />
    </div>
  );
}

export default CameraOff;
